import React, { Fragment, useEffect, useState } from "react";
import { useFormik } from "formik";
import styles from "./add-car.module.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL, carInit, POST_CAR } from "../../../constant-value";
import { carSchema } from "../../../constant-value/schema";
import alphabet from "../../../constant-value/alphaet.json";
import { IoChevronBackCircle, IoChevronBackOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import api from "../../../services/axiosConfig";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import { selectCars } from "../../../redux/car/car-slice";

const AddCar = () => {
  const user = useSelector((state) => state.user.user);
  // const userId = useSelector((state) => state.user.userId); // خواندن شناسه کاربر
  // const expireDate = useSelector((state) => state.user.expireDate);
  const cars = useSelector(selectCars);
  // const { id } = useParams();
  const [car, setCar] = useState(carInit);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);

  const navigate = useNavigate();

  const closeHandler = () => {
    navigate(-1);
  };

  useEffect(() => {
    setCar({
      ...car,
      userId: user.userId
    })
  }, [user.userId]);

  const stringChangeHandler = (evt) => {
    setFieldValue(evt.target.id, evt.target.value);
  }

  const numberChangeHandler = (evt) => {
    // setFieldValue(evt.target.id, parseFloat(evt.target.value));
    const value = evt.target.value; 
    // اگر خالی بود، null یا undefined قرار بده، نه NaN
    if (value === '') {
        setFieldValue(evt.target.id, null);
        setSubmitting(false);
        return;
    }  
    const numberValue = parseFloat(value);
    // اگر عدد معتبر است ذخیره کن، در غیر این صورت null
    const finalValue = isNaN(numberValue) ? null : numberValue; 
    setFieldValue(evt.target.id, finalValue);
    setSubmitting(false);
  }

  const message = (message,type) => {
    if (type==='warn') {
      toast.warning(message, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.success(message, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue, // 👈 اینو اضافه کن
    setSubmitting
  } = useFormik({
    enableReinitialize: true,
    initialValues: car,
    validationSchema: carSchema,
    // onSubmit,
    onSubmit: (values) => {
      if (user.expireDate === null && cars.length >= 1) {
          message('اشتراک شما پایان یافته است، لطفا اشتراک جدید تهیه نمایید','warn');
          return;
      }
      if (cars.length >= 5) {
        message('حداکثر 5 خودرو می توانید تعریف کنید','warn');
        return;
      }

      const fd = new FormData();
      // فیلدها
      Object.keys(values).forEach((key) => {
        fd.append(key, values[key] ?? "");
      });

      // فایل تصویر
      if (selectedFile) {
        if (!selectedFile.type.startsWith("image/")) {
          toast.error("فقط فایل تصویری مجاز است!");
          return;
        }
        if (selectedFile.size > 2 * 1024 * 1024) {
          toast.error("حجم تصویر نباید بیشتر از 2 مگابایت باشد!");
          return;
        }
        fd.append("file", selectedFile);
      }

      api.post(`${POST_CAR}`, fd)
          .then((res) => {
            if (res.data.isSuccess) {
              navigate('/');
              message(res.data.message,'success');
          } else {
              message(res.data.message,'warn');    
          }});

      // axios.post(`${BASE_URL}${POST_CAR}`, values).then((res) => {
      //   if (res.data.isSuccess) {
      //     navigate(-1);
      //     message(res.data.message,'success');
      // } else {
      //     message(res.data.message,'warn');    
      // }
      // });
    },
  });

  return (
    <Fragment>
      <div className="container py-4">
        <div className="card shadow-sm border-0">
          {/* هدر فرم با دکمه بازگشت */}
          <div className="card-header bg-muted d-flex align-items-center justify-content-between position-relative">         
            <h2 className="text-center mb-1">
              خودروی جدید
              <small className="d-block text-muted fs-6 mt-1">
                خودرو یا دستگاه خود را تعریف نمایید
              </small>
            </h2>
            
            <motion.button
              type="button"
              className="btn btn-light btn-sm rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "36px", height: "36px" }}
              onClick={closeHandler}
              aria-label="بازگشت"
              whileHover={{ scale: 1.15, rotate: -10 }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: "spring", stiffness: 300, damping: 10 }}
            >
              <IoChevronBackOutline size={20} />
            </motion.button>
          </div>
 
          {/* بدنه فرم */}
          <form onSubmit={handleSubmit} className="card-body p-4">
            {/* فیلدهای فرم */}
            <div className="row g-3">

              {/* Car Image */}
              <div className="col-md-6 text-center mb-4">
                <img
                  src={
                    selectedFile
                      ? URL.createObjectURL(selectedFile)
                      : values.imageUrl || BASE_URL + "/Images/Car/car.png"
                  }
                  alt="profile"
                  className="rounded-circle shadow-sm mb-2"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "cover",
                  }}
                />
                <div>
                  <label className="btn btn-outline-primary btn-sm mt-2">
                    انتخاب تصویر
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) setSelectedFile(file);
                      }}
                    />
                  </label>
                </div>
              </div>

              {/* نام خودرو */}
              <div className="col-md-6">
                <div className="form-floating">
                  <input
                    id="title"
                    type="text"
                    value={values.title}
                    onChange={stringChangeHandler}
                    onBlur={handleBlur}
                    className={`form-control ${
                      errors.title && touched.title ? "is-invalid" : ""
                    }`}
                    placeholder="نام خودرو"
                  />
                  <label htmlFor="title">نام خودرو</label>
                  {errors.title && touched.title && (
                    <div className="invalid-feedback">{errors.title}</div>
                  )}
                </div>
              </div>

              {/* شرکت سازنده */}
              <div className="col-md-6">
                <div className="form-floating">
                  <input
                    id="company"
                    type="text"
                    value={values.company}
                    onChange={stringChangeHandler}
                    onBlur={handleBlur}
                    className={`form-control ${
                      errors.company && touched.company ? "is-invalid" : ""
                    }`}
                    placeholder="شرکت سازنده"
                  />
                  <label htmlFor="company">
                    شرکت سازنده <span className="text-muted">(اختیاری)</span>
                  </label>
                  {errors.company && touched.company && (
                    <div className="invalid-feedback">{errors.company}</div>
                  )}
                </div>
              </div>

              {/* سال ساخت */}
              <div className="col-md-6">
                <div className="form-floating">
                  <input
                    id="productYear"
                    type="text"
                    inputMode="numeric"
                    value={values.productYear}
                    onChange={numberChangeHandler}
                    onBlur={handleBlur}
                    className={`form-control ${
                      errors.productYear && touched.productYear
                        ? "is-invalid"
                        : ""
                    }`}
                    placeholder="سال ساخت"
                  />
                  <label htmlFor="productYear">سال ساخت</label>
                  {errors.productYear && touched.productYear && (
                    <div className="invalid-feedback">{errors.productYear}</div>
                  )}
                </div>
              </div>

              {/* شماره شاسی */}
              <div className="col-md-6">
                <div className="form-floating">
                  <input
                    id="shasiNo"
                    type="text"
                    value={values.shasiNo}
                    onChange={stringChangeHandler}
                    onBlur={handleBlur}
                    className={`form-control ${
                      errors.shasiNo && touched.shasiNo ? "is-invalid" : ""
                    }`}
                    placeholder="شماره شاسی"
                  />
                  <label htmlFor="shasiNo">
                    شماره شاسی<span className="text-muted">(اختیاری)</span>
                  </label>
                  {errors.shasiNo && touched.shasiNo && (
                    <div className="invalid-feedback">{errors.shasiNo}</div>
                  )}
                </div>
              </div>

              {/* مصرف سوخت */}
              <div className="col-md-6">
                <div className="form-floating">
                  <input
                    id="useFuel"
                    type="text"
                    inputMode="numeric"
                    value={values.useFuel}
                    onChange={numberChangeHandler}
                    onBlur={handleBlur}
                    className={`form-control ${
                      errors.useFuel && touched.useFuel ? "is-invalid" : ""
                    }`}
                    placeholder="مصرف سوخت"
                  />
                  <label htmlFor="useFuel">
                    مصرف سوخت در 100 کیلومتر
                  </label>
                  {errors.useFuel && touched.useFuel && (
                    <div className="invalid-feedback">{errors.useFuel}</div>
                  )}
                </div>
              </div>

              {/* کیلومتر فعلی */}
              <div className="col-md-6">
                <div className="form-floating">
                  <input
                    id="kilometer"
                    type="text"
                    inputMode="numeric"
                    value={values.kilometer}
                    onChange={numberChangeHandler}
                    onBlur={handleBlur}
                    className={`form-control ${
                      errors.kilometer && touched.kilometer ? "is-invalid" : ""
                    }`}
                    placeholder="کیلومتر فعلی"
                  />
                  <label htmlFor="kilometer">کیلومتر فعلی (km)</label>
                  {errors.kilometer && touched.kilometer && (
                    <div className="invalid-feedback">{errors.kilometer}</div>
                  )}
                </div>
              </div>

              {/* متوسط حرکت هفتگی */}
              <div className="col-md-6">
                <div className="form-floating">
                  <input
                    id="distancePerWeek"
                    type="text"
                    inputMode="numeric"
                    value={values.distancePerWeek}
                    onChange={numberChangeHandler}
                    onBlur={handleBlur}
                    className={`form-control ${
                      errors.distancePerWeek && touched.distancePerWeek
                        ? "is-invalid"
                        : ""
                    }`}
                    placeholder="متوسط حرکت هفتگی"
                  />
                  <label htmlFor="distancePerWeek">
                    متوسط حرکت هفتگی (km)
                  </label>
                  {errors.distancePerWeek && touched.distancePerWeek && (
                    <div className="invalid-feedback">
                      {errors.distancePerWeek}
                    </div>
                  )}
                </div>
              </div>

              {/* بخش پلاک */}
              <div className="col-md-6 mt-3">
                <label className="form-label mb-3">پلاک خودرو</label>
                <div className="d-flex flex-wrap align-items-center gap-2">

                  {/* قسمت چهارم پلاک */}
                  <div style={{ width: "60px" }}>
                    <input
                      id="pelak4"
                      type="text"
                      inputMode="numeric"
                      value={values.pelak4}
                      onChange={numberChangeHandler}
                      onBlur={handleBlur}
                      className={`form-control text-center ${
                        errors.pelak4 && touched.pelak4 ? "is-invalid" : ""
                      }`}
                      maxLength="2"
                    />
                  </div>

                  {/* قسمت سوم پلاک */}
                  <div style={{ width: "60px" }}>
                    <input
                      id="pelak3"
                      type="text"
                      inputMode="numeric"
                      value={values.pelak3}
                      onChange={numberChangeHandler}
                      onBlur={handleBlur}
                      className={`form-control text-center ${
                        errors.pelak3 && touched.pelak3 ? "is-invalid" : ""
                      }`}
                      maxLength="3"
                    />
                  </div>

                  {/* قسمت دوم پلاک (حروف) */}
                  <div style={{ width: "80px" }}>
                    <select
                      id="pelak2"
                      name="pelak2"
                      onChange={(e) => {
                        console.log("selected:", e.target.value);
                        setFieldValue("pelak2", e.target.value);
                      }}
                      value={values.pelak2}
                      className="form-select text-center"
                    >
                      {alphabet.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* قسمت اول پلاک */}
                  <div style={{ width: "60px" }}>
                    <input
                      id="pelak1"
                      type="text"
                      inputMode="numeric"
                      value={values.pelak1}
                      onChange={numberChangeHandler}
                      onBlur={handleBlur}
                      className={`form-control text-center ${
                        errors.pelak1 && touched.pelak1 ? "is-invalid" : ""
                      }`}
                      maxLength="2"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* دکمه ارسال */}
            <div className="d-grid mt-4">
                <button 
                  className="btn btn-primary w-100 py-2 rounded-3 fw-bold" 
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      در حال تایید...
                    </>
                  ) : 'تایید'}
                </button>
              {/* <button
                type="submit"
                disabled={isSubmitting}
                className="btn btn-primary py-2"
              >
                تایید
              </button> */}
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default AddCar;
